import { z } from "zod";

export const authUserSchema = z.object({
  id: z.string().min(1),
  username: z.string().min(1),
  email: z.email(),
  nameEn: z.string().nullable(),
  nameAr: z.string().nullable(),
  userType: z.enum(["staff", "customer"]),
  // null for the tenant's own staff (ADMIN/EMPLOYEE) — only a customer has one.
  account: z
    .object({
      id: z.string().min(1),
      nameEn: z.string().optional(),
      nameAr: z.string().optional(),
    })
    .nullable(),
  isAccountAdmin: z.boolean(),
  permissions: z.array(z.string().min(1)),
});

export const sessionSchema = z.object({
  accessToken: z.string().min(1),
  user: authUserSchema,
});

export const loginResultSchema = z.union([
  z.object({ requiresOtp: z.literal(true) }),
  sessionSchema.extend({ requiresOtp: z.literal(false).optional() }),
]);

// The activation-link flow (level-1/staff first-time password setup) is
// unrelated to and unaffected by the OTP-based reset-password flow below --
// this is its own, still-live status union.
export const activationLinkStatusSchema = z.enum([
  "VALID",
  "EXPIRED",
  "SUPERSEDED",
  "ALREADY_USED",
  "INVALID",
]);

export type AuthUser = z.infer<typeof authUserSchema>;
export type AuthSession = z.infer<typeof sessionSchema>;
export type LoginResult = z.infer<typeof loginResultSchema>;
export type ActivationLinkStatus = z.infer<typeof activationLinkStatusSchema>;
